import { z } from 'zod'
import { makeFieldKeys } from '../../core/utils/utilities.ts'

export const ReportingDefaultSortModelSchema = z
  .object({
    id: z.string(),
    reporting_config_id: z.string(),
    sequence: z.number(),
    field_name: z.string(),
    direction: z.string()
  })
  .strict()

const ReportingDefaultSortModelFields = makeFieldKeys(ReportingDefaultSortModelSchema)

export type ReportingDefaultSortModel = z.infer<typeof ReportingDefaultSortModelSchema>
